module.exports = __webpack_public_path__ + "static/media/upld-middl-img.79088d08.jpg";